module.exports = __webpack_public_path__ + "static/media/intranet_eldorado.39d330ab.png";